import type { Invite, InviteForm } from '@cobliteam/common-types';
import moment from 'moment';
import { severinoDateFormat } from '../severino';
import type { IInviteForm, IPendingInvite } from './Types';

export const convertIPendingInviteToInvite = (pendingInvite: IPendingInvite): Invite => ({
  emailAddress: pendingInvite.email_address,
  creationDate: moment.utc(pendingInvite.creation_date, severinoDateFormat).valueOf(),
  token: pendingInvite.token,
  fleetId: pendingInvite.fleet_id,
  creatorId: pendingInvite.creator_id,
  role: pendingInvite.role,
  groupsRestriction: pendingInvite.groups_restriction,
});

export const convertInviteFormToIInviteForm = (inviteForm: InviteForm): IInviteForm => ({
  email_address: inviteForm.email,
  role: inviteForm.role,
  groups_restriction: inviteForm.groupsRestriction,
  custom_permissions: inviteForm.customPermissions,
  suggested_user_name: inviteForm.suggestedUserName,
});
